import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useApiClientContext } from '../../contexts/apiClient';

export interface ICancelMeetingResponse {
	success: boolean;
	message: string;
}

interface ICancelMeetingParams {
	meetingId: string;
	reason?: string;
}

export const useCancelMeetingMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Error) => void;
	onSuccess?: (data: ICancelMeetingResponse) => void;
} = {}) => {
	const { apiClient } = useApiClientContext();

	return useMutation({
		mutationFn: async ({ meetingId, reason }: ICancelMeetingParams): Promise<ICancelMeetingResponse> => {
			const response = await fetch(`${apiClient.baseUrl}/scheduler/${encodeURIComponent(meetingId)}/cancelbycontact`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json; charset=utf-8',
					Accept: 'application/json',
					Pragma: 'no-cache',
					'Cache-Control': 'no-cache',
				},
				body: JSON.stringify({ reason: reason || undefined }),
			});

			const result: Api.IOperationResult<ICancelMeetingResponse> = await response.json();

			if (!result.success || !result.value?.success) {
				throw new Error(result.systemMessage || result.value?.message || 'Failed to cancel meeting');
			}

			return result.value;
		},
		onSuccess,
		onError,
	});
};
